import Constant from '@/const';
import axios from 'axios';

const getUnsolvedSatuSehatPatients = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/ihs/encounter/unsolved'),
      {
        params,
      },
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getUnsolvedSatuSehatPatients;
